/** 0:42:18.6 or 42:18.6, tenths by default. */
export function formatElapsed(ms: number, decimals = 1): string {
  const neg = ms < 0;
  const abs = Math.abs(ms);
  const h = Math.floor(abs / 3_600_000);
  const m = Math.floor((abs % 3_600_000) / 60_000);
  const s = (abs % 60_000) / 1000;
  const ss = s.toFixed(decimals).padStart(decimals ? 3 + decimals : 2, '0');
  const body = h ? `${h}:${String(m).padStart(2, '0')}:${ss}` : `${m}:${ss}`;
  return neg ? `−${body}` : body;
}

export function formatAgo(ms: number): string {
  const s = Math.round(ms / 1000);
  if (s < 60) return `${s} s ago`;
  const m = Math.round(s / 60);
  return m < 60 ? `${m} min ago` : `${Math.round(m / 60)} h ago`;
}

export function percent(x: number | null | undefined): string {
  return x === null || x === undefined ? '—' : `${Math.round(x * 100)}%`;
}
